import ResponsiveImage from '~/components/Image/ResponsiveImage'
import { LearningProduct } from '~/MathTopics/types/math-topic.type'
import { getAspectRatio } from '~/MathTopics/utils/math-topic.utils'

interface Props {
  item: LearningProduct
}

const mediaQuery = [
  { screen: '(max-width: 767px)', width: '20vw' },
  { screen: '(min-width: 768px)', width: '15vw' },
]

export default function GameModules(props: Props): React.ReactElement {
  const { item } = props

  const aspectRatio = getAspectRatio(item.type || '')
  return (
    <div className="flex flex-col items-center justify-center h-28 px-2 py-4 text-center">
      <div className="h-auto mt-4 last:mb-0 leading-4 tracking-widest">
        <ResponsiveImage
          alt={item.title}
          height={aspectRatio.height}
          imageClassName={`w-auto ${item.type === 'stacknload' ? 'h-25' : 'h-20'} mb-3.5`}
          mediaQuery={mediaQuery}
          srcKey={
            item.type === 'treasureTrail' || item.type === 'stacknload'
              ? `math-topics/games/${item.type}-v4.png`
              : `math-topics/games/${item.type}-v3.png`
          }
          width={aspectRatio.width}
        />
      </div>
    </div>
  )
}
